<template><div><h1 id="artikelliste-nach-wochen-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#artikelliste-nach-wochen-export-fur-excel"><span>Artikelliste nach Wochen, Export für Excel</span></a></h1>
<p>Artikelliste nach Wochen, Export für Excel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei mit Umsätzen für die gewünschten Artikel. Die Auswertung gruppiert die Daten primär nach Artikeltyp (A, N, F), eine Sortierung nach Produkt Manager und Artikelgruppe kann gewählt werden. Eingegrenzt werden kann nach Kalenderwochen und Mediennummer. Der Output gibt wahlweise Werte aus für Artikeldetails, Artikelgruppen und nur Totalwerte aus. Retouren werden nicht berücksichtigt, sind in den Gesamtumsätzen also als positiver Umsatz enthalten.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikelliste nach Wochen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Artikelnummer</dt>
<dd>von Artikelnummer, leer = alle, inklusive</dd>
<dt>bis Artikelnummer</dt>
<dd>bis Artikelnummer, leer = alle, inklusive</dd>
<dt>Det/Grup/Total</dt>
<dd>D = Artikeldetail, G = Artikelgruppe, T = Total</dd>
<dt>von ArtGruppe</dt>
<dd>von Artikelgruppe, leer = alle, inklusive</dd>
<dt>bis ArtGruppe</dt>
<dd>bis Artikelgruppe, leer = alle, inklusive</dd>
<dt>PM</dt>
<dd>Produkt Manager, leer = alle</dd>
<dt>von Woche,Jahr</dt>
<dd>Woche, Jahr, inklusive</dd>
<dt>bis Woche,Jahr</dt>
<dd>Woche, Jahr, inklusive</dd>
<dt>Medium</dt>
<dd>Mediennummer, leer = alle</dd>
<dt>Ausgabe</dt>
<dd>Standard (Textdatei)</dd>
</dl>
<h2 id="output" tabindex="-1"><a class="header-anchor" href="#output"><span>Output</span></a></h2>
<p>Output nach Artikelgruppen</p>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtGrp</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>Typ</td>
<td>Artikeltyp (N, A, F)</td>
</tr>
<tr>
<td>PM</td>
<td>Produkt Manager</td>
</tr>
<tr>
<td>VL von [Woche]</td>
<td>Verkaufsmenge in den ausgewerteten Wochen an Wiederverkäufer</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufswert in den ausgewerteten Wochen an Wiederverkäufer</td>
</tr>
<tr>
<td>Vtot von [Woche]</td>
<td>Gesamte Verkaufsmenge in den ausgewerteten Wochen</td>
</tr>
<tr>
<td>Wert</td>
<td>Gesamter Verkaufswert in den ausgewerteten Wochen</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel nach Artikelgruppen</p>
<p>ArtGrp  Typ     VL von  1 W-1998 bis  3 W-1998  Wert   VTot von 1 W-1998 bis 3 W-1998 Wert
100     A       0       0.00    0       0.00
21100   A       33      229.00  35      252.00
22000   A       50      367.00  59      469.00
22100   A       36      1342.00 74      4119.00
31100   A       0       0.00    0       0.00
31400   A       0       0.00    0       0.00
31900   A       0       0.00    0       0.00
32100   A       2       26.00   13      191.00
32200   A       10      68.00   16      128.00
33200   A       2       55.00   5       172.00
33310   A       2       26.00   2       26.00
33320   A       0       0.00    0       0.00
34100   A       0       0.00    0       0.00
34200   A       0       0.00    0       0.00
41100   A       0       0.00    0       0.00
42100   A       2       121.00  7       554.00
42900   A       0       0.00    0       0.00
500     A       0       0.00    0       0.00
51110   A       1       20.00   8       138.00
51130   A       0       0.00    0       0.00
.</p>
<p>Lesebeispiel: Die Artikelgruppe 32200 gehört zu den assemblierten Artikeln. Bei Wiederverkäufern wurden im ausgewerteten Zeitraum (Wochen 1 bis 3 im Jahr 1998) 10 Stk. für Fr. 68.-- verkauft, insgesamt wurden 16 Stk. im Wert von Fr. 128.-- verkauft.</p>
<p>Output nur Totalwerte</p>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Typ</td>
<td>Artikeltyp (A, N, F)</td>
</tr>
<tr>
<td>VL von [Woche]</td>
<td>Anzahl verkaufte Menge bei Wiederverkäufern</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufsumsatz bei Wiederverkäufern</td>
</tr>
<tr>
<td>VTot von [Woche]</td>
<td>Anzahl verkaufte Menge aller Aufträge im ausgewerteten Zeitraum</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufsumsatz aller Aufträge</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel mit Totalwerten</p>
<p>Typ     VL von  1 W-1998 bis  3 W-1998  Wert    VTot von  1 W-1998 bis 3 W-1998 Wert
A       250     5059.00 575     14232.00
N       7336    150225.00       29619   377643.00</p>
<p>Lesebeispiel: In den Wochen 1 bis 3 im Jahr 1998 wurden 7'336 Normalartikel im Gesamtwert von Fr. 150'225.-- an Wiederverkäufer verkauft. Insgesamt waren es 29'619 Artikel im Wert von Fr. 377'643.--.</p>
<p>Output mit Artikeldetails</p>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Rekapitulation</td>
<td>analog Totalwerte</td>
</tr>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Typ</td>
<td>Artikeltyp (N, A, F)</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>PM</td>
<td>Produktmanager</td>
</tr>
<tr>
<td>VkPreis</td>
<td>Verkaufpreis</td>
</tr>
<tr>
<td>EkPreis</td>
<td>Einkaufpreis</td>
</tr>
<tr>
<td>VL von [Woche]</td>
<td>Anzahl verkaufte Menge bei Wiederverkäufern im ausgewerteten Zeitraum</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufsumsatz bei Wiederverkäufern</td>
</tr>
<tr>
<td>VTot von [Woche]</td>
<td>Anzahl verkaufte Menge aller Aufträge im ausgewerteten Zeitraum</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufsumsatz aller Aufträge</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel mit Artikeldetails</p>
<p>Typ	VL von  1 W-1998 bis  3 W-1998	Wert	VTot von  1 W-1998 bis  3 W-1998	Wert
A	250	5059.00	575	14232.00
N	7336	150225.00	29619	377643.00
8347.93	A	Salzstreuer + Pfeffermühle		we	69.00	0.00	0	0.00	1	69.00
0083.00	A	Freilandlabor Natur	100	ms	27.00	0.00	0	0.00	0	0.00
0148.00	A	Kapuzen-Schlafsack doppelt	100	ms	160.00	0.00	0	0.00	0	0.00
0173.01	A	Infoblatt Energie	100	mbe	3.00	0.00	0	0.00	0	0.00
0255.93	A	Strickjupe + Longpulli mint, M	100	sg	89.00	0.00	0	0.00	0	0.00
0255.94	A	Strickjupe + Longpulli mint, L	100	sg	89.00	0.00	0	0.00	0	0.00
7103.15	N	Sportslip Seide beige Gr. XL	100	sg	25.00	21.17	0	0.00	0	0.00
7104.83	N	Hemd 'Kelim' bunt, 38	100	sg	69.00	40.44	0	0.00	0	0.00
7104.87	N	Hemd 'Kelim' bunt, 42	100	sg	69.00	40.44	0	0.00	0	0.00
7104.88	N	Hemd 'Kelim' bunt, 43	100	sg	69.00	40.44	0	0.00	0	0.00
7105.12	N	Top breite Träger weiss Gr. S	100	sg	35.00	24.05	0	0.00	0	0.00</p>
<p>Lesebeispiel: Der Sportslip mit Artikelnummer 7103.15 hat einen Verkaufspreis von Fr. 25.-- und einen Einkaufspreis von Fr. 21.17. Weder im Wiederverkauf noch im normalen Verkauf wurde in den ersten 3 Wochen von 1998 ein Umsatz damit gemacht.</p>
</div></template>


